import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import uz from './locales/uz.json';
import kor from './locales/kor.json';
import ru from './locales/ru.json';

i18n.use(initReactI18next).init({
  resources: {
    uz: { translation: uz },
    en: { translation: en },
    ko: { translation: kor },
    ru: { translation: ru },
  },
  lng: 'uz', // Default til
  fallbackLng: 'uz', // Til topilmasa, ushbu tilga qaytadi
  interpolation: {
    escapeValue: false, // XSS himoyasi uchun
  },
});

export default i18n;
